/** 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
 * Pure presentation labels; the host translation provider supplies its locale.
 */
import { createContext, useContext, type ReactNode } from 'react';

export interface ModalLabels {
    close: string;
    modalFocus: string;
    modalFullscreen: string;
    modalRestore: string;
}

const defaults: ModalLabels = {
    close: 'Kapat',
    modalFocus: 'Forma odaklan',
    modalFullscreen: 'Tam ekrana geç',
    modalRestore: 'Eski boyuta dön',
};
const ModalLabelsContext = createContext<ModalLabels>(defaults);

export function ModalLabelsProvider({ labels, children }: { labels: Partial<ModalLabels>; children: ReactNode }) {
    return <ModalLabelsContext.Provider value={{ ...defaults, ...labels }}>{children}</ModalLabelsContext.Provider>;
}

export function useModalLabels(): ModalLabels {
    return useContext(ModalLabelsContext);
}
